var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutUs1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 419 378",
    style: {
      enableBackground: "new 0 0 419 378"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F1F2FB;}\r\n\t.st1{fill:#E5E8F6;}\r\n\t.st2{fill:#CFD4EE;}\r\n\t.st3{fill:#384DB8;}\r\n\t.st4{fill:#485BBE;}\r\n\t.st5{fill:#DBDFF2;}\r\n\t.st6{fill:none;stroke:#485BBE;stroke-miterlimit:10;}\r\n\t.st7{fill:none;stroke:#CFD4EE;stroke-width:14;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st8{fill:#D5DAF0;}\r\n\t.st9{fill:#FFFFFF;}\r\n\t.st10{fill:#ADB6E2;}\r\n\t.st11{fill:none;stroke:#485BBE;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st12{fill:none;stroke:#485BBE;stroke-width:1;stroke-linecap:round;stroke-miterlimit:9.9999;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 198,
    cy: 193.9,
    rx: 180.2,
    ry: 172.3
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "66.5,233.3 92.9,254.8 106.8,253.2 106.8,225.2 71.1,212.1 65.6,231.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.8,253.2H93.5v-53.9c0-10.4,8.5-18.9,18.9-18.9h52.4L164.8,253.2L164.8,253.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "93.5,162.8 135.2,140.7 130.6,125.7 85,138.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M125.4,155.8h18.2v-26.7c0-7-5.6-12.6-12.6-12.6h-5.6L125.4,155.8L125.4,155.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.2,144c8.2,11.3,6,26.8-4.9,34.7s-26.3,5.1-34.5-6.2s-6-26.8,4.9-34.7C113.6,130,129,132.7,137.2,144z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M135.7,151c0.1,3.9,3.3,7,7.2,7c3.9-0.1,7-3.3,7-7.2c-0.1-3.9-3.3-7-7.2-7 C138.8,143.9,135.7,147.1,135.7,151z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M136.4,156.3l1.7-0.5l0.6-25.1c-0.3-4.9-6.6-8-11.5-7.7l-6.6,0.4l8.9,29.2 C130.3,155.5,133.4,157.2,136.4,156.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M123.4,141.6c-5.7,3.3-13.9,7.1-22.8,8.2c-16.9,2.2-30.1-14.4-24.4-30.4l1.8-5.1c0,0,4.6,6.2,16.2,2 c14.4-5.2,32-6.9,36.6,6C133.4,129.6,130.1,137.7,123.4,141.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M140.7,182.9c-3.7,4.3-6.7,6.7-7.6,7.4c-0.2,0.1-0.3,0.2-0.3,0.2l-1.1,0.7c-1.9,1.1-4.3,1.8-6.9,1.8 c-0.2,0-0.4,0-0.5,0c-2.3-1.3-4.2-3.3-5.2-6.1l-1.5-3.8l-1.1-2.7l12-4.7l7.8-3.1l0.3-0.1l0.5,1.3L140.7,182.9z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 144.7,
    cy: 151.5,
    r: 11.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M136.4,184.2c0,2.4-1.2,4.6-3.3,6.2c-0.2,0.1-0.3,0.2-0.3,0.2l-1.1,0.7c-1.9,1.1-4.3,1.8-6.9,1.8 c-0.2,0-0.4,0-0.5,0c-6.1-0.2-11-4.1-11-8.9c0-0.5,0.1-1,0.2-1.5c0.9-4.2,5.7-7.4,11.4-7.4c1.3,0,2.5,0.2,3.7,0.5 c1.5,0.4,2.8,1,4,1.8c0.2,0.2,0.5,0.3,0.7,0.5C135.2,179.6,136.4,181.8,136.4,184.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M156.2,154.3c-0.2,0.6-0.4,1.1-0.5,1.7c-4.1,12.5-10.1,21.4-14.9,27c-3.7,4.3-6.7,6.7-7.6,7.4 c-0.2,0.1-0.3,0.2-0.3,0.2l-1.1,0.7l-4.6-8.9c0.8-0.6,1.6-1.3,2.3-1.9c1.1-0.9,2.1-1.9,3-2.9c1.5-1.6,2.8-3.2,3.9-4.8 c2.4-3.5,4.1-6.9,5.2-9.7c0.1-0.4,0.3-0.7,0.4-1.1c0.6-1.5,1-2.9,1.2-3.9c0.4-1.4,0.5-2.2,0.5-2.2l4.8-0.6L156.2,154.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M133.7,182l10.6,5.5c2.2,1.2,5,0.3,6.2-2l7.1-13.8c1.2-2.2,0.3-5-2-6.2L145,160c-2.2-1.2-5-0.3-6.2,2 l-7.1,13.8C130.6,178,131.4,180.8,133.7,182z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "45.5,239 73,193 85.2,200.8 58.7,244.9 46.7,253  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M74.2,225.1h-8c-3,0-5.4-2.4-5.4-5.4l0,0c0-3,2.4-5.4,5.4-5.4h8c3,0,5.4,2.4,5.4,5.4l0,0 C79.6,222.6,77.2,225.1,74.2,225.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M51.7,229.6l-2-1c-2.8-1.4-3.9-4.8-2.6-7.6l5.4-10.8c1.4-2.8,4.8-3.9,7.6-2.6l2,1c2.8,1.4,3.9,4.8,2.6,7.6 L59.3,227C57.9,229.9,54.5,231,51.7,229.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M70.7,196.8l12.5,7.3l2.7-4.2c2.2-3.4,1.2-7.9-2.2-10.1l0,0c-3.5-2.2-8.1-1.1-10.3,2.4L70.7,196.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st5",
    points: "45.5,238.8 58.7,244.9 50.7,250.4 46.4,248.7  "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M111,259.8H35.7c-1.8,0-3.3-1.5-3.3-3.3l0,0c0-1.8,1.5-3.3,3.3-3.3H111c1.8,0,3.3,1.5,3.3,3.3l0,0 C114.3,258.3,112.8,259.8,111,259.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M126.8,193c0,4.8-4,4.8-4,9.5c0,4.8,4,4.8,4,9.5c0,4.8-4,4.8-4,9.5c0,4.8,4,4.8,4,9.6s-4,4.8-4,9.6"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M297.7,101.7v85.4c0,13.6-12.8,23.6-26,20.4l-35.7-8.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M310.1,130.6v57.1c0,10.3-4.7,19.9-12.8,26.3c-6,4.7-13.2,7.1-20.5,7.1c-2.7,0-5.4-0.3-8.1-1l-35.7-8.8 c-6.7-1.6-10.7-8.4-9.1-15c1.7-6.7,8.4-15.7,15-14.1l35.7,8.8c3.5,0.9,6.1-0.6,7.3-1.6c1.2-1,3.3-3.1,3.3-6.7v-52.1H310.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M293.6,70.6L293.6,70.6c-2.2,0-4,1.8-4,4V108c0,2.2,1.8,4,4,4l0,0c2.2,0,4-1.8,4-4V74.6 C297.6,72.4,295.8,70.6,293.6,70.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 298.6,
    cy: 102.7,
    rx: 13.9,
    ry: 13.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M188.4,176.1l18.8,55.9l-3.3,75.1h-41.6v-71.5l-7.4,10.9l-3.8,5.5l-12.3,18l-0.1,0.1l-5.2-3.4l-8.5-5.5 l-2.2-1.4c-0.2-0.2-0.5-0.3-0.7-0.5l0,0c-1.2-0.9-2.1-2-2.8-3.3l0,0c-0.6-1.3-1-2.7-1.1-4.1c-0.1-2.1,0.4-4.2,1.6-6.2l1.4-2.2 l4.1-6.4l31.1-48.1c0.1-0.2,0.3-0.4,0.4-0.6c2.2-3.2,5.1-5.8,8.5-7.5c2.1-1.1,4.4-1.9,6.8-2.2l6-1L188.4,176.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M217.9,156v19.3c0,4.6-2.1,8.7-5.1,10.6l-5.5-5.9l-5.4,6.2c-3.3-1.8-5.6-6-5.6-10.9V156H217.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "207.2,179.9 201.8,186.1 198.6,189.8 188.2,176.9 196.1,170.9 196.2,171  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "226,176.9 216,189.5 212.7,185.9 207.2,179.9 217.9,171.1 218.1,170.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "254.6,186.1 254.6,192.5 254.6,197.9 254.6,203.2 254.6,203.3 254.5,216.5 254.5,224.7 254.5,308.4  204,308.4 207.2,231.9 226.4,177.1 232.8,179.1 240,181.4 243.8,182.6 245.9,183.3 251.1,184.9 251.4,185 252.4,185.3  253.8,185.8 253.9,185.8  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288,
    y: 125.8,
    className: "st9",
    width: 19.4,
    height: 4.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 185.1,
    y: 110,
    className: "st2",
    width: 45.6,
    height: 15.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M184.2,133c-4.5,13.2,2.1,27.4,14.8,31.7c12.7,4.4,26.6-2.8,31.2-15.9c4.5-13.2-2.1-27.4-14.8-31.7 C202.7,112.7,188.8,119.8,184.2,133z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M233.3,119.4c0,0-6.9,3.7-16.2,6.1c-5,1.2-10.6,2.1-16.4,1.9c-17-0.7-27.2-19.3-18.7-34.2l2.7-4.8 c0,0,3.4,6.9,15.6,4.8C219.5,89.8,242.9,92.9,233.3,119.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M239.9,138.7c0,3.9-3.2,7.1-7.1,7.1s-4.4-3.2-4.4-7.1c0-3.9,0.5-7.1,4.4-7.1S239.9,134.8,239.9,138.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M187.6,135.7c1.1,3.8-1.1,7.7-4.9,8.8c-3.8,1.1-7.7-1.1-8.8-4.9c-1.1-3.8,1.1-7.7,4.9-8.8 C182.6,129.8,186.6,132,187.6,135.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M233.1,140.9h1.7l5.7-23.9c1.1-4.8-1.8-9.5-6.6-10.7l-6.4-1.5v30.5C227.5,138.4,230,140.9,233.1,140.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M182.7,140.4H181l-5.7-23.9c-1.1-4.8,1.8-9.5,6.6-10.7l6.4-1.5v30.5C188.3,137.9,185.8,140.4,182.7,140.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M93.6,238.6c6.5,10.3,30.1,45.8,35,53.3c0.6,0.9,1.6,1.4,2.6,1.4h48.4c2.4,0,3.9-2.6,2.7-4.7l-31-52 c-0.6-1-1.6-1.5-2.7-1.5c-8.3,0.1-42.8,0.6-53.5,0.7C93.7,235.8,92.9,237.4,93.6,238.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M116.2,275.6l-2,1c-2.8,1.4-6.2,0.2-7.6-2.6l-5.3-10.9c-1.4-2.8-0.2-6.2,2.6-7.6l2-1c2.8-1.4,6.2-0.2,7.6,2.6 l5.3,10.9C120.2,270.8,119.1,274.2,116.2,275.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.4,
    y: 285,
    className: "st10",
    width: 74.8,
    height: 23.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "201.8,186.1 206.1,191.3 201,213.5 207.2,231.9 213.1,215.1 209.2,190.6 212.7,185.9 207.2,179.9  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 123.1,
    y1: 252.5,
    x2: 140.4,
    y2: 252.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 125.9,
    y1: 258,
    x2: 143.1,
    y2: 258
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M277.2,280.4c-1.8,0-2.9-1.8-2.2-3.4l26.4-56.7c1.1-2.3,3.3-3.7,5.8-3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M373.9,280.7h-93.3c-1.8,0-2.9-1.8-2.2-3.4l26.4-56.7c1.1-2.3,3.3-3.7,5.8-3.7h90.7c1.8,0,2.9,1.8,2.2,3.4 l-27.4,59C375.7,280.1,374.8,280.7,373.9,280.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "330.2,303.5 316.2,303.5 336.3,260.5 350.3,260.5  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 280,
    y: 303.5,
    className: "st3",
    width: 73.7,
    height: 4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 313.7,
    y1: 303.5,
    x2: 334.6,
    y2: 259.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st11",
    cx: 334.7,
    cy: 165.9,
    r: 3.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 263.3,
    y1: 84.3,
    x2: 263.3,
    y2: 92.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st11",
    x1: 267.2,
    y1: 88.2,
    x2: 259.3,
    y2: 88.2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "78.9,273.6 81.8,278.6 84.7,283.6 78.9,283.6 73.2,283.6 76,278.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M67.2,168.6c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7C66,165.9,67.2,167.1,67.2,168.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143.1,
    y: 91.3,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -24.0375 131.3099)",
    className: "st12",
    width: 6.8,
    height: 6.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "280,250.5 278.7,309.4 237.6,311.1 244.8,265.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M256.9,295.3h-34.3v-59.4h43.5c10.6,0,17.3,11.3,12.2,20.6L256.9,295.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M256,262.5c-0.2,3.7,6.9,7.5,6,11.1c-0.4,1.7-1.4,3.6-2,5.2c-0.7,1.8-1.4,3.7-2.6,6.2 c-1.4,3-10.6,6.5-12.5,10.2c-0.9,1.8-1.8,3.6-2.8,5.4c-1.3,2.5-2.6,5.1-4,7.6H185l0.1-0.8h-8.4c-0.1,0-0.2,0-0.3,0 c-6.7-0.1-11.8-3.9-14.5-8.9c-2.1-4-2.7-8.7-1.2-13.2c0.3-0.9,0.7-1.9,1.2-2.8c0.7-1.2,1.5-2.4,2.5-3.5l4.4-5.9l8-10.6L188,248 l1.8-2.3c1.3-1.7,2.8-3.2,4.4-4.6c4.7-3.8,10.6-6,16.8-6h23.7c0,0,0,0.2,0.1,0.4c0.1,0.1,0.1,0.2,0.2,0.4 c1.1,2.2,5.6,8.3,19.5,4.4h0.1c0,0,0.1,0.3,0.2,0.9C255.3,244,256.6,252.9,256,262.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M258.3,288.7l18.3,2c3.2,0.3,6.1,2.1,7.9,4.7l9.1,13l-12.9,1.1l-22.6-8.7L258.3,288.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "283.1,212.9 241.3,190.8 245.9,175.8 291.5,188.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M251.1,205.9h-18.2v-26.7c0-7,5.6-12.6,12.6-12.6h5.6V205.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M239.4,194.1c-8.2,11.3-6,26.8,4.9,34.7c10.9,7.9,26.3,5.1,34.5-6.2c8.2-11.3,6-26.8-4.9-34.7 C262.9,180.1,247.5,182.9,239.4,194.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M240.8,201.1c-0.1,3.9-3.3,7-7.2,7c-3.9-0.1-7-3.3-7-7.2c0.1-3.9,3.3-7,7.2-7 C237.7,194,240.8,197.2,240.8,201.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M240.1,206.4l-1.7-0.5l-2.5-24.6c0.3-4.9,8.5-8.5,13.4-8.2l6.6,0.4l-8.9,29.2 C246.2,205.6,243.1,207.3,240.1,206.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M253.1,191.7c5.7,3.3,13.9,7.1,22.8,8.2c16.9,2.2,30.1-14.4,24.4-30.4l-1.8-5.1c0,0-4.6,6.2-16.2,2 c-14.4-5.2-32-6.9-36.6,6C243.1,179.7,246.4,187.8,253.1,191.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M260,230.6l-2.5,6.4c-3.7,9.5-17.1,10.5-21.8,1.4c-0.7-1.4-1-2.5-1-2.5l5.2-13.2L260,230.6z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "234.8,244.7 234.7,285.8 253.3,288.2 259.7,244.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "228.2,235.1 237.3,229.1 249.7,243.3 259.1,233.3 264,236.2 254.6,254.9 250,247.5 241.8,254.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "243.8,253.1 246,257.8 234.7,285.8 253.3,288.2 249.4,259.1 253.6,253.3 250,247.5  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st11",
    points: "258.3,288.7 198,282.7 205.3,265.6  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M374.5,314.8H55c-2,0-3.7-1.6-3.7-3.7l0,0c0-2,1.6-3.7,3.7-3.7h319.5c2,0,3.7,1.6,3.7,3.7l0,0 C378.2,313.1,376.5,314.8,374.5,314.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs1);
export default __webpack_public_path__ + "static/media/aboutUs-1.2c2d72ffc16b7f4b992bf81429a6f6b3.svg";
export { ForwardRef as ReactComponent };